export default state => state.savedItems.loadingDataOnPageLoad;
